import { render, staticRenderFns } from "./vip-customer-approved.vue?vue&type=template&id=3238d4d0&scoped=true"
import script from "./vip-customer-approved.vue?vue&type=script&lang=js"
export * from "./vip-customer-approved.vue?vue&type=script&lang=js"
import style0 from "./vip-customer-approved.vue?vue&type=style&index=0&id=3238d4d0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3238d4d0",
  null
  
)

export default component.exports